import { sample } from 'effector'

import * as chat from '@/entities/chat'
import * as profile from '@/entities/profile/portal'

sample({
    clock: [profile.portalProfileAPI.logout.done, profile.unauthorized],
    target: chat.userLogout,
})
